import { Component, OnInit } from '@angular/core';
import { QueryEditorBase } from 'src/core/models/query/query-editor-base';
import { Operators } from 'src/core/models/request/operator.enum';
import { Observable } from 'rxjs';
import { GenericLookupDto } from 'src/core/models/generic-lookup/generic-lookup.dto';
import { GenericLookupTypeState } from 'src/core/states/generic-lookup-type/generic-lookup-type.state';
import { map } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { IntegerQueryItemDto } from 'src/core/models/query/integer-query-item.dto';
import { CustomerGender } from 'src/core/models/generic-lookup-type/global/customer-gender.glt';
import { GenericLookupTypeService } from 'src/core/services/generic-lookup-type/generic-lookup-type.service';

@Component({
    selector: 'ca-query-tree-node-customer-gender',
    templateUrl: './query-tree-node-customer-gender.component.html',
    styleUrls: ['./query-tree-node-customer-gender.component.scss'],
    standalone: false
})
export class QueryTreeNodeCustomerGenderComponent extends QueryEditorBase implements OnInit {
  genders$: Observable<GenericLookupDto[]>;
  payload: IntegerQueryItemDto;
  currentGender: string;

  constructor(private operators: Operators, private store: Store, private genericLookupService: GenericLookupTypeService) {
    super();

    this.genders$ = this.store
      .select(GenericLookupTypeState.getGenericLookups)
      .pipe(map(filterFn => filterFn(CustomerGender)));
  }

  operatorChanged() {
    this.node.isDirty = true;
  }

  valueChanged() {
    this.node.isDirty = true;
    this.payload.genericLookupCode = this.genericLookupService.findGenericLookupWithId(this.payload.value)?.code;
  }

  ngOnInit() {
    this.payload = this.node.categoryItem.payload as IntegerQueryItemDto;
    this.node.validationStatus = true;

    this.genders$.subscribe((genders: GenericLookupDto[]) => {
      const gender = genders.find(x => x.id == this.payload.value);
      this.currentGender = gender.name;
      this.payload.genericLookupCode = gender.code;
    });
  }
}
